import { SystemSetting } from '@/types';

export function defaultValues(setting?: SystemSetting) {
  return {
    id: setting?.id || '',
    name: setting?.name || '',
    subTitle: setting?.subTitle || '',
    heroDescription: setting?.heroDescription || '',
    servicesTitle: setting?.servicesTitle || '',
    servicesDescription: setting?.servicesDescription || '',
    aboutTitle: setting?.aboutTitle || '',
    aboutDescription: setting?.aboutDescription || '',
    contactOne: setting?.contactOne || '',
    whatsApp: setting?.whatsApp || '',
    address: setting?.address || '',
    email: setting?.email || '',
    contactTwo: setting?.contactTwo || '',
    contactThree: setting?.contactThree || '',
    facebook: setting?.facebook || '',
    twitter: setting?.twitter || '',
    instagram: setting?.instagram || '',
    linkedIn: setting?.linkedIn || '',
    youTube: setting?.youTube || '',
    description: setting?.description || '',
    image: setting?.image || '',
    icon: setting?.icon || '',
    createdDate: setting?.createdDate || new Date().toISOString(),
    createdUser: setting?.createdUser || '',
  } as SystemSetting;
}
